import React from "react";
import { NakiNigunAlbumTrackProducerEditTemplate } from "themes/administration/naki-nigun/components";
import { NakiNigunAlbumTrackProducerEditViewStore } from "administration/naki-nigun/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiNigunAlbumTrackProducerEditViewStore(rootStore, componentProps),
    "nakiNigunAlbumTrackProducerEditViewStore"
)
class NakiNigunAlbumTrackProducerEdit extends React.Component {
    render() {
        return <NakiNigunAlbumTrackProducerEditTemplate {...this.props} />;
    }
}

export default NakiNigunAlbumTrackProducerEdit;
